import atom from 'atom-js';
import store from 'helpers/store';

const model = atom.setup({
  modelName: 'appState',
  persistenceLib: store,
})(store.get('appState') || {});

export default model;
